import product from './product.js';

export default (cart, removedProduct) => ({
	event: 'removeFromCart',
	ecommerce: {
		currencyCode: cart.order.currency,
		remove: {
			products: [product(removedProduct)], // Create a product object
			actionField: {
				affiliation: cart.url.hostname
			}
		}
	},
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
